import { Card } from "../api";


export const soundMap: Record<string, string> = {
"FlipCard":"FlipCard",
"PlaceBet":"PlaceBet",
"SelectBtn":"SelectBtn",
"Collect":"Collect"
};


export const cardMap: Record<Card, string> = {
       "C10": "Clubs_10.png",
        "C2": "Clubs_2.png",
        "C3": "Clubs_3.png",
        "C4": "Clubs_4.png",
        "C5": "Clubs_5.png",
        "C6": "Clubs_6.png",
        "C7": "Clubs_7.png",
        "C8": "Clubs_8.png",
        "C9": "Clubs_9.png",
        "CA": "Clubs_Ace.png",
        "CJ": "Clubs_Jack.png",
        "CK": "Clubs_King.png",
        "CQ": "Clubs_Queen.png",
       "D10": "Diamonds_10.png",
        "D2": "Diamonds_2.png",
        "D3": "Diamonds_3.png",
        "D4": "Diamonds_4.png",
        "D5": "Diamonds_5.png",
        "D6": "Diamonds_6.png",
        "D7": "Diamonds_7.png",
        "D8": "Diamonds_8.png",
        "D9": "Diamonds_9.png",
        "DA": "Diamonds_Ace.png",
        "DJ": "Diamonds_Jack.png",
        "DK": "Diamonds_King.png",
        "DQ": "Diamonds_Queen.png",
       "H10": "Hearts_10.png",
        "H2": "Hearts_2.png",
        "H3": "Hearts_3.png",
        "H4": "Hearts_4.png",
        "H5": "Hearts_5.png",
        "H6": "Hearts_6.png",
        "H7": "Hearts_7.png",
        "H8": "Hearts_8.png",
        "H9": "Hearts_9.png",
        "HA": "Hearts_Ace.png",
        "HJ": "Hearts_Jack.png",
        "HK": "Hearts_King.png",
        "HQ": "Hearts_Queen.png",
       "S10": "Spades_10.png",
        "S2": "Spades_2.png",
        "S3": "Spades_3.png",
        "S4": "Spades_4.png",
        "S5": "Spades_5.png",
        "S6": "Spades_6.png",
        "S7": "Spades_7.png",
        "S8": "Spades_8.png",
        "S9": "Spades_9.png",
        "SA": "Spades_Ace.png",
        "SJ": "Spades_Jack.png",
        "SK": "Spades_King.png",
        "SQ": "Spades_Queen.png",
    };